/* GENERATED by shopify/make-personalize.js — prices and dimensions
   come from ccd-data.js, so this is derived, never a second list. */
window.MW_PERSONALIZE = {
  "personalized-cutting-board": {
    "template": "personalize-board",
    "sizeOption": "Size",
    "sizes": [
      {
        "value": "Small",
        "dim": "9\" × 12\""
      },
      {
        "value": "Medium",
        "dim": "11\" × 15\""
      },
      {
        "value": "Large",
        "dim": "15\" × 20\""
      }
    ],
    "intro": "Type what it should say. The lettering below is a sample of the style you pick — I set the final layout on the machine and send you a proof before anything is cut.",
    "fields": [
      {
        "id": "line1",
        "prop": "Line 1",
        "label": "Line 1 — the name",
        "max": 28,
        "placeholder": "The Mellons"
      },
      {
        "id": "line2",
        "prop": "Line 2",
        "label": "Line 2 — a date or short phrase",
        "max": 28,
        "placeholder": "est. 3-19-18",
        "optional": true
      }
    ],
    "fonts": [
      {
        "id": "script",
        "label": "Script",
        "css": "'Dancing Script', 'Segoe Script', cursive",
        "weight": 700
      },
      {
        "id": "block",
        "label": "Block",
        "css": "'Archivo', 'Helvetica Neue', sans-serif",
        "weight": 700,
        "upper": true
      },
      {
        "id": "serif",
        "label": "Serif",
        "css": "'Cormorant Garamond', Georgia, serif",
        "weight": 600
      }
    ],
    "engraving": {
      "fee": 30,
      "label": "Engraving — front"
    },
    "addons": [
      {
        "label": "Engraving — message on the back",
        "price": 18,
        "note": "A dedication on the reverse face.",
        "field": {
          "id": "backMsg",
          "prop": "Message on the back",
          "max": 120
        }
      },
      {
        "label": "Rubber feet",
        "price": 12,
        "note": "Keeps the board still on the counter."
      },
      {
        "label": "Filled engraving (solid surface only)",
        "price": 38,
        "note": "Colour packed into the cut and levelled flush. Solid surface only.",
        "onlyWhen": "Solid surface"
      }
    ]
  },
  "custom-word-cutout": {
    "template": "personalize-cutout",
    "sizeOption": "Size",
    "sizes": [
      {
        "value": "6 inches",
        "dim": "6 inches tall · about ¾ inch thick"
      },
      {
        "value": "12 inches",
        "dim": "12 inches tall · about ¾ inch thick"
      },
      {
        "value": "18 inches",
        "dim": "18 inches tall · about ¾ inch thick"
      },
      {
        "value": "24 inches",
        "dim": "24 inches tall · about ¾ inch thick"
      },
      {
        "value": "36 inches",
        "dim": "36 inches tall · about ¾ inch thick"
      }
    ],
    "intro": "Type the word. The lettering below is a sample of the style you pick — you approve a proof of the real cut before I start.",
    "fields": [
      {
        "id": "word",
        "prop": "Word",
        "label": "Your word or name",
        "max": 18,
        "placeholder": "faith"
      }
    ],
    "fonts": [
      {
        "id": "script",
        "label": "Script",
        "css": "'Dancing Script', 'Segoe Script', cursive",
        "weight": 700
      },
      {
        "id": "block",
        "label": "Block",
        "css": "'Archivo', 'Helvetica Neue', sans-serif",
        "weight": 700,
        "upper": true
      },
      {
        "id": "serif",
        "label": "Serif",
        "css": "'Cormorant Garamond', Georgia, serif",
        "weight": 600
      }
    ],
    "engraving": null,
    "extraChar": {
      "after": 6,
      "fee": 5
    },
    "addons": [
      {
        "label": "Keyhole slots routed in back",
        "price": 8,
        "note": "So it sits flat against the wall."
      }
    ]
  },
  "engraved-coasters": {
    "template": "personalize-coasters",
    "sizeOption": "Size",
    "sizes": [
      {
        "value": "Set of 4",
        "dim": "Four 4\" × 4\" coasters"
      },
      {
        "value": "Set of 6",
        "dim": "Six 4\" × 4\" coasters"
      }
    ],
    "intro": "Type what should be cut into them. The same lettering goes on every coaster in the set, and the engraving is already in the price. The sample below shows the style you pick — I send you a proof before anything is cut.",
    "fields": [
      {
        "id": "line1",
        "prop": "Line 1",
        "label": "Line 1 — a name, a monogram or a short line",
        "max": 22,
        "placeholder": "The Mellons"
      },
      {
        "id": "line2",
        "prop": "Line 2",
        "label": "Line 2 — a date or a second line",
        "max": 22,
        "placeholder": "est. 3-19-18",
        "optional": true
      }
    ],
    "fonts": [
      {
        "id": "script",
        "label": "Script",
        "css": "'Dancing Script', 'Segoe Script', cursive",
        "weight": 700
      },
      {
        "id": "block",
        "label": "Block",
        "css": "'Archivo', 'Helvetica Neue', sans-serif",
        "weight": 700,
        "upper": true
      },
      {
        "id": "serif",
        "label": "Serif",
        "css": "'Cormorant Garamond', Georgia, serif",
        "weight": 600
      }
    ],
    "engraving": null,
    "addons": []
  },
  "state-shape-board": {
    "template": "personalize-state",
    "intro": "Pick your state and I cut the board to its outline. Add a name or a date if you want one — the lettering below is a sample of the style you pick.",
    "selects": [
      {
        "id": "state",
        "prop": "State",
        "label": "Your state",
        "options": [
          "Alabama",
          "Alaska",
          "Arizona",
          "Arkansas",
          "California",
          "Colorado",
          "Connecticut",
          "Delaware",
          "Florida",
          "Georgia",
          "Hawaii",
          "Idaho",
          "Illinois",
          "Indiana",
          "Iowa",
          "Kansas",
          "Kentucky",
          "Louisiana",
          "Maine",
          "Maryland",
          "Massachusetts",
          "Michigan",
          "Minnesota",
          "Mississippi",
          "Missouri",
          "Montana",
          "Nebraska",
          "Nevada",
          "New Hampshire",
          "New Jersey",
          "New Mexico",
          "New York",
          "North Carolina",
          "North Dakota",
          "Ohio",
          "Oklahoma",
          "Oregon",
          "Pennsylvania",
          "Rhode Island",
          "South Carolina",
          "South Dakota",
          "Tennessee",
          "Texas",
          "Utah",
          "Vermont",
          "Virginia",
          "Washington",
          "West Virginia",
          "Wisconsin",
          "Wyoming"
        ],
        "value": "Michigan",
        "note": "Every state is the same price. Cut to its own outline, 11\" × 15\" at the widest point."
      }
    ],
    "fields": [
      {
        "id": "line1",
        "prop": "Line 1",
        "label": "Line 1 — optional",
        "max": 28,
        "placeholder": "The Merriweathers",
        "optional": true
      },
      {
        "id": "line2",
        "prop": "Line 2",
        "label": "Line 2 — optional",
        "max": 28,
        "placeholder": "Michigan",
        "optional": true
      }
    ],
    "fonts": [
      {
        "id": "script",
        "label": "Script",
        "css": "'Dancing Script', 'Segoe Script', cursive",
        "weight": 700
      },
      {
        "id": "block",
        "label": "Block",
        "css": "'Archivo', 'Helvetica Neue', sans-serif",
        "weight": 700,
        "upper": true
      },
      {
        "id": "serif",
        "label": "Serif",
        "css": "'Cormorant Garamond', Georgia, serif",
        "weight": 600
      }
    ],
    "engraving": {
      "fee": 30,
      "label": "Engraving — front"
    },
    "addons": [
      {
        "label": "Rubber feet",
        "price": 12,
        "note": "Keeps the board still on the counter."
      }
    ]
  },
  "led-signs": {
    "template": "artwork-led",
    "sizeOption": "Size",
    "sizes": [
      {
        "value": "Small",
        "dim": "5\" × 7\""
      },
      {
        "value": "Medium",
        "dim": "8\" × 10\""
      },
      {
        "value": "Large",
        "dim": "11\" × 14\""
      }
    ]
  }
};
